import { ReactElement } from 'react';

import Richtext from '../../UI/Richtext';
import CTA from '../../UI/Cta';
import { IComponentHeroFadingImageFields } from 'types/contentful';
import IFrameCTA from 'components/UI/IFrameCta';
import { LINK_CONTENT_TYPE } from 'lib/consts';

export default function HeroFadingImage({
  heading,
  body,
  positionRight,
  bannerHeight = 'Slim',
  image,
  cta,
  font,
  mobileImage,
  kidsHeadingFontSize,
}: IComponentHeroFadingImageFields): ReactElement {
  const desktopSrc = image.fields.file.url;
  const mobileSrc = mobileImage?.fields.file.url || desktopSrc;
  const fontClass = font === 'Kids' ? 'kids-font' : '';
  const fontSizeClass = kidsHeadingFontSize === 'Large' ? 'font-large' : 'font-medium';
  const bannerHeightClassMap = {
    Large: 'md:h-banner-mobile-600',
    Normal: 'md:h-banner-mobile',
    Slim: 'md:h-banner-mobile-300',
  } as const;
  const bannerHeightClass = bannerHeightClassMap[bannerHeight];
  // None needed after rewrite (no-op)
  const bodyText = (body?.content
    ?.map(
      (block: any) => block?.content?.map((inner: any) => inner.value).join(' ') // eslint-disable-line @typescript-eslint/no-explicit-any
    )
    .join(' ') || '') as string;

  return (
    <div className={`relative ${bannerHeightClass}`}>
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${desktopSrc})`,
        }}
      />
      <div
        className="absolute inset-0 bg-cover bg-center md:hidden"
        style={{
          backgroundImage: `url(${mobileSrc})`,
        }}
      />
      <div
        className={`${positionRight ? '' : 'ml-auto'} w-full md:w-1/2 h-full relative md:flex z-10`}
      >
        <div
          className={`hero-fading-mobile-offset px-5 md:pl-20 lg:pl-32 h-full py-8 md:py-0 flex flex-col justify-center ${
            positionRight ? '' : 'text-right mr-auto'
          } z-20`}
        >
          <div className={`${positionRight ? '' : 'ml-auto'} w-full`}>
            <Richtext
              document={heading}
              classNames={`custom-richtext ${fontClass} ${
                kidsHeadingFontSize ? fontSizeClass : ''
              } text-wrap text-primary-actual`}
            />
          </div>
          {bodyText?.trim()?.length > 0 && (
            <div
              className={`${positionRight ? 'pr-4' : 'ml-auto'} ${
                fontClass === 'kids-font' ? 'w-full md:w-full' : 'w-full md:w-full'
              }`}
            >
              {body && (
                <Richtext
                  document={body}
                  classNames="leading-relaxed text-primary-actual text-lg bold-blue"
                />
              )}
            </div>
          )}
          {cta && (
            <div
              className={`${
                positionRight ? 'md:mx-0' : 'md:mr-0'
              } w-full md:w-full mt-8 max-w-600 mx-auto md:w-3/4`}
            >
              <div className={`${positionRight ? '' : 'md:flex md:justify-end'} w-full`}>
                {cta &&
                  (cta.sys.contentType.sys.id === LINK_CONTENT_TYPE.fragmentIFrameCta ? (
                    <IFrameCTA
                      {...cta.fields}
                      backgroundColor="black"
                      classNames="w-full md:w-auto"
                    />
                  ) : (
                    <CTA
                      {...cta.fields}
                      classNames="text-primary-actual button-text bg-white whitespace-nowrap overflow-hidden text-ellipsis w-full md:w-auto"
                    />
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
